<div class="modal fade" bsModal #editTicket="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1" role="dialog" aria-labelledby="dialog-static-name">
  <div class="modal-dialog modal-fullscreen modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
          <h5 class="modal-title">EDIT TICKET</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="hide()"></button>
      </div>
      <div class="modal-body" *ngIf="selectedTicket">

          <div class="ticket-sla-dashboard">
            <div class="ticket-sla-dashboard__grid">
              <div class="ticket-sla-dashboard__item" [ngClass]="getSlaLevelCardClass(selectedTicket.slaLevel)">
                <div class="ticket-sla-dashboard__label">SLA Level</div>
                <div class="ticket-sla-dashboard__value">{{selectedTicket.slaLevel || 'No SLA Purchased'}}</div>
              </div>
              <div class="ticket-sla-dashboard__item" [ngClass]="getSlaMetricCardClass(selectedTicket.acknowledgeSlaRemainingPercent)">
                <div class="ticket-sla-dashboard__label">Acknowledge Remaining</div>
                <div class="ticket-sla-dashboard__value">
                  {{selectedTicket.acknowledgeSlaRemainingPercent == null ? 'N/A' : (selectedTicket.acknowledgeSlaRemainingPercent | number:'1.0-1') + '%'}}
                  <i *ngIf="isTicketAcknowledged(selectedTicket)" class="bi bi-check-circle-fill text-success ms-1" title="Acknowledged"></i>
                </div>
                <div class="ticket-sla-dashboard__subvalue">{{getSlaHoursDisplay(selectedTicket, 'acknowledge')}}</div>
              </div>
              <div class="ticket-sla-dashboard__item" [ngClass]="getSlaMetricCardClass(selectedTicket.completeSlaRemainingPercent)">
                <div class="ticket-sla-dashboard__label">Complete Remaining</div>
                <div class="ticket-sla-dashboard__value">
                  {{selectedTicket.completeSlaRemainingPercent == null ? 'N/A' : (selectedTicket.completeSlaRemainingPercent | number:'1.0-1') + '%'}}
                  <i *ngIf="isTicketCompleted(selectedTicket)" class="bi bi-check-circle-fill text-success ms-1" title="Completed"></i>
                </div>
                <div class="ticket-sla-dashboard__subvalue">{{getSlaHoursDisplay(selectedTicket, 'complete')}}</div>
              </div>
            </div>
          </div>

          <div class="row g-3 ticket-edit-layout">
            <div class="col-lg-5 ticket-edit-col">
              <div class="form-group input-group-sm">
                  <label>Name</label>
                  <input class="form-control form-control-sm" [(ngModel)]="selectedTicket.title" placeholder="Enter ticket title" maxlength="100" />
              </div>

              <div class="form-group input-group-sm">
                  <label>Priority</label>
                  <select class="form-select form-select-sm" [(ngModel)]="selectedTicket.priority.id">
                    <option *ngFor="let priority of priorityTypes" [value]="priority.id">{{priority.priority}}</option>
                  </select>
              </div>

              <div class="form-group input-group-sm" *ngIf="statusTypes && statusTypes.length > 0">
                  <label>Status</label>
                  <select class="form-select form-select-sm" [(ngModel)]="selectedTicket.status.id">
                    <option *ngFor="let status of statusTypes" [value]="status.id">{{status.status}}</option>
                  </select>
              </div>

              <div class="form-group input-group-sm" *ngIf="azureAuthService.isAdmin()">
                  <label>Customer</label>
                  <select class="form-select form-select-sm" [(ngModel)]="selectedTicket.customerId" (ngModelChange)="onCustomerChanged()">
                    <option *ngFor="let c of allCustomers" [value]="c.customerId">{{c.customerName}}</option>
                  </select>
              </div>

              <div class="form-group input-group-sm" *ngIf="users && users.length > 0 && azureAuthService.isAdmin()">
                  <label>Assigned To</label>
                  <select class="form-select form-select-sm" [(ngModel)]="selectedTicket.assignedToUserId">
                    <option [value]="-1">Unassigned</option>
                    <option *ngFor="let user of getFilteredUsers()" [value]="user.userId">{{user.displayName}} ({{user.customerName}})</option>
                  </select>
              </div>

              <div class="form-group input-group-sm" *ngIf="!azureAuthService.isAdmin()">
                  <label>Assigned To</label>
                  <input class="form-control form-control-sm" [value]="selectedTicket.assignedToUser" disabled />
              </div>
            </div>

            <div class="col-lg-7 d-flex">
              <div class="form-group input-group-sm ticket-description-group">
                  <label>Description</label>
                  <angular-editor
                    class="ticket-description-editor"
                    [config]="descriptionEditorConfig"
                    [(ngModel)]="descriptionHtml"
                    (ngModelChange)="onDescriptionEditorChange($event)">
                  </angular-editor>
              </div>
            </div>
          </div>

          <br/>
          <hr/>
          <br/>
          <h5 class="h5">Notes</h5>

          <div class="mt-2 messenger-content">
            <div class="messenger-content-body">
              <div data-scrollbar="true" data-height="100%" class="ps ps--active-y" style="height: 100%;" data-init="true">
                <div class="widget-chat" *ngIf="selectedTicket.notes && selectedTicket.notes.length > 0; else noNotes">
                  <div class="widget-chat-item" *ngFor="let note of selectedTicket.notes" [ngClass]="{'reply': note.enteredByUser != azureAuthService.userProfile.fullName}">
                    <div class="widget-chat-content">
                      <div class="widget-chat-name">{{note.enteredByUser}}</div>
                      <div class="widget-chat-message last">
                        {{note.note}}
                      </div>
                      <div class="widget-chat-status">{{note.createdDate | relativeDate}}</div>
                    </div>
                  </div>
                </div>
                <ng-template #noNotes>
                  <div class="widget-chat-item">
                    <div class="widget-chat-content">
                      <div class="widget-chat-name">No notes available for this ticket.</div>
                    </div>
                  </div>
                </ng-template>
              </div>
            </div>
            <div class="messenger-content-footer">
              <div class="input-group input-group-lg position-relative z-3">
                <button class="btn text-inverse position-absolute start-0" type="button"><i class="far fa-face-smile"></i></button>
                <input type="text" class="form-control rounded-start ps-45px" placeholder="Write a note..." [ngModel]="noteText" (ngModelChange)="onNoteTextChanged($event)" maxlength="5000" (keyup.enter)="onAddNote()"/>
                <button class="btn btn-outline-default" type="button" (click)="onAddNote()"><i class="fa fa-paper-plane text-muted"></i></button>
              </div>
            </div>
          </div>
      </div>
      <div class="modal-footer" *ngIf="selectedTicket">
        <button class="btn btn-w-m btn-outline btn-warning"
                (click)="onAcknowledge()"
                [disabled]="!canAcknowledgeTicket(selectedTicket)"
                *ngIf="!isTicketAcknowledged(selectedTicket)">Acknowledge</button>
        <div class="fw-400 ms-auto me-2" *ngIf="selectedTicket.status.id < 4">
          <button class="btn badge border border-secondary text-secondary" (click)="onAcceptOwnership()" *ngIf="selectedTicket.assignedToUser == null && azureAuthService.isAdmin()">Accept Ownership</button>
        </div>
        <div class="fw-400 ms-auto me-2" *ngIf="selectedTicket.status.id == 4">
          <button class="btn badge border border-danger text-danger" (click)="onCloseTicket()" *ngIf="azureAuthService.isOwner() && azureAuthService.isAdmin()">Close Ticket</button>
        </div>

        <button class="btn btn-w-m btn-outline btn-default" (click)="hide()">Cancel</button>
        <button class="btn btn-w-m btn-outline btn-theme" (click)="onSave(); hide()">Save</button>
      </div>
    </div>
  </div>
</div>
